"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _appcenterApi = _interopRequireWildcard(require("../../../../@apis/appcenterApi"));
var _TabContext = require("../../contexts/TabContext");
var _AuthContext = require("../../contexts/AuthContext");
var _ExternalAuthContext = require("../../contexts/ExternalAuthContext");
var _constants = require("../../../../@constants");
var _AccountForm = _interopRequireDefault(require("./AccountForm"));
var _AccountCreated = _interopRequireDefault(require("./AccountCreated"));
var _InboxRequest = _interopRequireDefault(require("../../../../@custom/InboxRequest"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * @typedef User
 * @type {import("../../../../@apis/appcenterApi.js").User}
 */

/**
 * @typedef StepProps
 * @type {{
 *     user: User;
 *     updateUser: (updates: Partial<User>) => void;
 *     goNext?: (user: User) => void;
 * }}
 */

function ExternalRegister() {
  var _useContext = (0, _react.useContext)(_TabContext.TabContext),
    setTab = _useContext.setTab;
  var _useAuth = (0, _AuthContext.useAuth)(),
    app = _useAuth.app,
    showSpinner = _useAuth.showSpinner,
    hideSpinner = _useAuth.hideSpinner,
    showMessage = _useAuth.showMessage,
    domain = _useAuth.domain;
  var _useExternalAuth = (0, _ExternalAuthContext.useExternalAuth)(),
    license = _useExternalAuth.license;
  var _useState = (0, _react.useState)(STEPS.ACCOUNT_FORM),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var _useState3 = (0, _react.useState)(_appcenterApi.defaultUser),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    user = _useState4[0],
    setUser = _useState4[1];
  var registerTitle = _constants.registerPageConstants[app].title;
  var registerSubtitle = _constants.registerPageConstants[app].subtitle;

  /** @param {Partial<User>} updates */
  var handleUserUpdate = function handleUserUpdate(updates) {
    setUser(function (prev) {
      return _objectSpread(_objectSpread({}, prev), updates);
    });
  };
  console.log('domain: >=>', domain);

  /** @param {User} user */
  var createAccount = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(user) {
      var companyUid, name;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log('user', user);
            showSpinner();
            _context.prev = 2;
            companyUid = license.company;
            name = "".concat(user.firstName, " ").concat(user.lastName).trim().replace(/[\s]+/g, ' ');
            _context.next = 7;
            return _appcenterApi["default"].company.users.save(companyUid, _objectSpread(_objectSpread({}, user), {}, {
              name: name,
              external: true
            }));
          case 7:
            setUser(user);
            return _context.abrupt("return", true);
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            showMessage('Erro ao cadastrar usuário', /*#__PURE__*/_react["default"].createElement(_InboxRequest["default"], {
              error: _context.t0,
              additionalInfo: {
                user: user
              }
            }));
            return _context.abrupt("return", false);
          case 15:
            _context.prev = 15;
            hideSpinner();
            return _context.finish(15);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 11, 15, 18]]);
    }));
    return function createAccount(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * @param {number} currentStep
   * @returns {(newUser: User) => Promise<void>}
   **/
  var handleGoNextStep = function handleGoNextStep(currentStep) {
    return /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(newUser) {
        var success;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              setUser(newUser);
              console.log('currentStep', currentStep);
              _context2.t0 = currentStep;
              _context2.next = _context2.t0 === STEPS.ACCOUNT_FORM ? 5 : _context2.t0 === STEPS.ACCOUNT_CREATED ? 11 : 11;
              break;
            case 5:
              console.log('creating');
              _context2.next = 8;
              return createAccount(newUser);
            case 8:
              success = _context2.sent;
              if (success) setStep(STEPS.ACCOUNT_CREATED);
              return _context2.abrupt("break", 12);
            case 11:
              return _context2.abrupt("break", 12);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
  };
  (0, _react.useEffect)(function () {
    localStorage.setItem('user', JSON.stringify(user));
  }, [JSON.stringify(user)]);
  var stepProps = {
    user: user,
    updateUser: handleUserUpdate
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Auth-right-form"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Auth-right-form-textBox"
  }, /*#__PURE__*/_react["default"].createElement("h1", null, registerTitle), /*#__PURE__*/_react["default"].createElement("p", null, registerSubtitle)), step === STEPS.ACCOUNT_FORM && /*#__PURE__*/_react["default"].createElement(_AccountForm["default"], (0, _extends2["default"])({}, stepProps, {
    goNext: handleGoNextStep(STEPS.ACCOUNT_FORM)
  })), step === STEPS.ACCOUNT_CREATED && /*#__PURE__*/_react["default"].createElement(_AccountCreated["default"], stepProps), /*#__PURE__*/_react["default"].createElement("p", {
    className: "Auth-right-form-centeredText"
  }, "J\xE1 tem conta?", ' ', /*#__PURE__*/_react["default"].createElement("span", {
    className: "Auth-right-form-link",
    onClick: function onClick() {
      return setTab('login');
    }
  }, "Clique aqui")));
}
var _default = ExternalRegister;
exports["default"] = _default;
var STEPS = {
  ACCOUNT_FORM: 0,
  ACCOUNT_CREATED: 1
};